<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off">
                            <input type="text" placeholder="search" (keyup.enter)="getLocationByWildSearch()"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                        </form>
                        <i class="bi bi-search" (click)="getLocationByWildSearch()"></i>
                    </div>
                    <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" (click)="mapLoad()"
                        data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate
                        }}</button>
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 20%;">{{ 'location.zone' | translate }}</th>
                        <th style="width: 20%;">{{ 'location.city' | translate }}</th>
                        <th style="width: 15%;">{{ 'location.provinceOrState' | translate }}</th>
                        <th style="width: 20%;">{{ 'location.country' | translate }}</th>
                        <th style="width: 15%;">{{ 'location.postalCode' | translate }}</th>

                        <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate
                            }}</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" id="{{location.id}}"
                    [ngClass]="{ 'delete-highlight': location.locationId == recordId }" *ngFor="let location of locationList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">

                    <p style="width: 20%;">{{location.zone || " -- " }}</p>
                    <p style="width: 20%;">{{location.city || " -- " }}</p>
                    <p style="width: 15%;">{{location.provinceOrState || " -- " }}</p>
                    <p style="width: 20%;">{{location.country || " -- " }}</p>
                    <p style="width: 15%;">{{location.postalCode || " -- " }}</p>

                    <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i data-toggle="modal" title="View"
                            (click)="viewLocationById(location.locationId)"
                            data-target="#viewModal" class="bi bi-eye-fill"></i>
                        <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square"
                            (click)="getLocationById(location.locationId)" data-toggle="modal"
                            data-target="#editModal"></i>
                        <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3"
                            (click)="deleteIdSelect(location.id,location)" data-toggle="modal"
                            data-target="#deleteModal"></i>
                    </p>
                </div>
            </div>


            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && locationList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>

            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>


        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteLocation()" class="btn btn-primary">{{ 'generic.delete' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'location.headings.add' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="locationForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.zone' | translate }} <span class="required">*</span></label>
                                <input formControlName="zone" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('zone').invalid && formSubmit">Zone required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.city' | translate }} <span class="required">*</span></label>
                                <input formControlName="city" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('city').invalid && formSubmit">City required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.provinceOrState' | translate }} <span class="required">*</span></label>
                                <input formControlName="provinceOrState" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('provinceOrState').invalid && formSubmit">Province or
                                    state required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.country' | translate }} <span class="required">*</span></label>
                                <input formControlName="country" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('country').invalid && formSubmit">Country
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.postalCode' | translate }} <span class="required">*</span></label>
                                <input formControlName="postalCode" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('postalCode').invalid && formSubmit">Postal/zip code
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label style="visibility: hidden;">Spacer</label>
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="stockPoint" type="checkbox" id="exampleCheck1">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="exampleCheck1" style="display: inline-block; margin-bottom: 0;">Stock Point</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{ 'Users Responsible' }}</label>
                                <ng-multiselect-dropdown [placeholder]="'Select Users'" [settings]="userDropdownSettings"
                                    [data]="userList" [(ngModel)]="userSelectedList"
                                    [ngModelOptions]="{standalone: true}">
                                </ng-multiselect-dropdown>
                                <span class="err" *ngIf="locationForm.get('stockPoint').value && userSelectedList.length == 0 && formSubmit">Please select at least one user when Stock Point is enabled</span>
                            </div>
                        </div>
                    </div>

                    <div class="map-frame mt-3">
                        <div id="map">
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>

                    <button type="button" (click)="addLocation()" class="btn btn-primary">{{ 'generic.add' | translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'location.headings.edit' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="locationUpdateForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.zone' | translate }} <span class="required">*</span></label>
                                <input formControlName="zone" type="text" class="form-control">
                                <span class="err" *ngIf="locationUpdateForm.get('zone').invalid && formSubmit">Zone required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.city' | translate }} <span class="required">*</span></label>
                                <input formControlName="city" type="text" class="form-control">
                                <span class="err" *ngIf="locationUpdateForm.get('city').invalid && formSubmit">City
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.provinceOrState' | translate }} <span class="required">*</span></label>
                                <input formControlName="provinceOrState" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="locationUpdateForm.get('provinceOrState').invalid && formSubmit">Province or state
                                    required</span>
                            </div>
                        </div>



                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.country' | translate }} <span class="required">*</span></label>
                                <input formControlName="country" type="text" class="form-control">
                                <span class="err" *ngIf="locationUpdateForm.get('country').invalid && formSubmit">Country
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.postalCode' | translate }} <span class="required">*</span></label>
                                <input formControlName="postalCode" type="text" class="form-control">
                                <span class="err" *ngIf="locationUpdateForm.get('postalCode').invalid && formSubmit">Postal code
                                    required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label style="visibility: hidden;">Spacer</label>
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="stockPoint" type="checkbox" id="editCheck1">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="editCheck1" style="display: inline-block; margin-bottom: 0;">Stock Point</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{ 'Users Responsible' }}</label>
                                <ng-multiselect-dropdown [placeholder]="'Select Users'" [settings]="userDropdownSettings"
                                    [data]="userList" [(ngModel)]="userSelectedList"
                                    [ngModelOptions]="{standalone: true}">
                                </ng-multiselect-dropdown>
                                <span class="err" *ngIf="locationUpdateForm.get('stockPoint').value && userSelectedList.length == 0 && formSubmit">Please select at least one user when Stock Point is enabled</span>
                            </div>
                        </div>
                    </div>

                    <div class="map-frame mt-3">
                        <div id="mapEdit">
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button id="closeModalButton3" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="updateLocation()" class="btn btn-primary">{{ 'generic.update' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="viewModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewModalLabel">View Location
                    <span class="header-action" data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="service-data" *ngFor="let viewData of singleLocationData">
                    <div class="form-group">
                        <div class="row" style="margin-bottom: 20px;">
                            <div class="col-md-6 col-lg-6">
                                <label>Country :</label>
                                <p>{{viewData.country || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Province/State :</label>
                                <p>{{viewData.provinceOrState || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>City :</label>
                                <p>{{viewData.city || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Zone :</label>
                                <p>{{viewData.zone || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Postal Code :</label>
                                <p>{{viewData.postalCode || '--'}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Stock Point :</label>
                                <p>{{viewData.stockPoint ? 'Yes' : 'No'}}</p>
                            </div>
                            <div class="col-md-12 col-lg-12 mt-2">
                                <label>Users Responsible :</label>
                                <div *ngIf="viewData.usersResponsible?.length > 0">
                                   <p *ngFor="let user of viewData.usersResponsible; let last = last">
                                      {{user.userName}}{{!last ? ',' : ''}}
                                   </p>
                                </div>
                                <p *ngIf="!viewData.usersResponsible || viewData.usersResponsible.length == 0">--</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="map-frame mt-3">
                    <div id="mapView" style="height: 400px; width: 100%;">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closePopUp()">{{ 'generic.close' | translate }}</button>
            </div>
        </div>
    </div>
</div>